export default __webpack_public_path__ + "static/media/application-for-employment-operational.1edec08d.pdf";